import { Injectable } from '@angular/core';

import { PriceBoostConfig } from '@frontend/sports/common/client-config-data-access';

import { SignpostType } from '../signpost.model';

@Injectable({ providedIn: 'root' })
export class SignpostTypeService {
    signpostType = SignpostType.None;

    constructor(private priceBoostConfig: PriceBoostConfig) {}

    get isPriceBoost(): boolean {
        return (this.priceBoostConfig.isEnabled || this.priceBoostConfig.isEnabledAPB) && this.signpostType === SignpostType.PriceBoost;
    }
}
